import { useState } from 'react'
import { LogOut, Moon } from 'lucide-react'
import { useAuth } from '../../contexts/AuthContext.tsx'

export default function AppHeader() {
  const { user, logout } = useAuth()
  const [open, setOpen] = useState(false)
  const [logoSrc, setLogoSrc] = useState('/icons/icon-192x192.png')
  const displayName = user?.display_name || 'Account'

  const handleLogout = async () => {
    setOpen(false)
    await logout()
  }

  return (
    <header className="safe-area-top sticky top-0 z-30 border-b border-surface-200 bg-white/95 backdrop-blur">
      <div className="flex items-center justify-between px-4 py-3">
        <div className="min-w-0">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand-600">Fairy Smiles</p>
          <p className="truncate text-sm text-text-600">{displayName}</p>
        </div>

        <div className="relative">
          <button
            type="button"
            onClick={() => setOpen((current) => !current)}
            className="flex items-center rounded-full border border-brand-100 bg-brand-50 p-1.5 shadow-sm transition hover:bg-brand-100"
            aria-expanded={open}
            aria-label="Open account menu"
          >
            {logoSrc ? (
              <img
                src={logoSrc}
                alt="Fairy Smiles"
                className="h-10 w-10 rounded-full object-contain sm:h-11 sm:w-11"
                onError={() => {
                  if (logoSrc === '/icons/icon-192x192.png') {
                    setLogoSrc('https://fairysmiles.co.uk/assets/images/logo.png')
                    return
                  }
                  setLogoSrc('')
                }}
              />
            ) : (
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-600 text-sm font-bold text-white sm:h-11 sm:w-11">
                FS
              </span>
            )}
          </button>

          {open && (
            <div className="absolute right-0 mt-2 w-48 overflow-hidden rounded-2xl border border-surface-200 bg-white shadow-xl">
              <button
                type="button"
                disabled
                className="flex w-full items-center gap-3 px-4 py-3 text-left text-sm text-text-400"
              >
                <Moon size={16} />
                Dark mode
              </button>
              <button
                type="button"
                onClick={() => void handleLogout()}
                className="flex w-full items-center gap-3 px-4 py-3 text-left text-sm font-medium text-text-700 transition hover:bg-surface-50"
              >
                <LogOut size={16} />
                Log out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  )
}
